<script>
    import Cinema from "../components/Cinema.svelte";
    import { onMount } from "svelte";
    import ajaxFetch from "../services/ajaxFetch";

    /**
 *
 *
 *
 *
 *
 *
 *
 */

    /*                */
    let {
        index,
        featureIndex,
        errorCallback,
        performance,
        cinemaInjectionContainerWidth,
        additionalTrackingLabels = null,
    } = $props();

    let cinemaHasLoaded = $state(false);
    let contentDresonRule = $state(),
        headline = $state(),
        recommendations = $state(),
        tracking = $state(),
        additionalClickTracking = $state(),
        metaData = $state(),
        featuresState = $state();

    onMount(async () => {
        performance.cinemaLoadingStarted();
        const res = await ajaxFetch(`/reco-core/recommendations/pwylo/`);
        if (res.status !== 200) {
            errorCallback();
            return;
        }
        ({
            dreson: contentDresonRule,
            headline,
            recommendations,
            tracking,
            additionalClickTracking,
            metaData,
            featuresState,
        } = await res.json());
        cinemaHasLoaded = true;
    });
</script>

{#if cinemaHasLoaded}
    <div class="reco_pwylo_cinema_wrapper">
        <Cinema
            {headline}
            {recommendations}
            {tracking}
            {featureIndex}
            {additionalClickTracking}
            {featuresState}
            {cinemaInjectionContainerWidth}
            cinemaIndex={index}
            cinemaMeta={metaData}
            {performance}
            {additionalTrackingLabels}
            site="reco_pwylo"
            {contentDresonRule}
        />
    </div>
{/if}

<style lang="scss">
    .reco_pwylo_cinema_wrapper {
        min-height: 360px;
        max-height: 672px;
        position: relative;
    }
</style>
